module.exports = __webpack_public_path__ + "static/office-2-4d8bc70ec92603fd4ef349ac786a08ca.webp";